<template>
	<form method="POST" id="PaymentForm" :action="stripe_action" class="form_style" v-on:submit.prevent.once data-cc-on-file="false" :data-stripe-publishable-key="this.stripe_key">
		<template v-if="this.bypass_payment=='1'">
			<h2>Place Order</h2>
		</template>
		<template v-else>
			<h2>Payment</h2>
		</template>
		<div class="wrapper">
			<template v-if="this.enabled_payment_methods > 1 && this.bypass_payment==false">
				<h3>Select a payment method</h3>
				<div class="grid">
					<p class="fancy_radio_button" v-if="stripe_enabled">
						<input type="radio" name="payment_type" id="payment_type_1" value="stripe" v-model="payment_method">
						<label for="payment_type_1">
							<i class="fal fa-credit-card"></i>
							<span><b>Credit/Debit Card</b></span>
							<span>Pay using your credit or debit card using our payment provider Stripe.</span>
						</label>
					</p>
					<p class="fancy_radio_button" v-if="paypal_enabled">
						<input type="radio" name="payment_type" id="payment_type_2" value="paypal" v-model="payment_method">
						<label for="payment_type_2">
							<i class="fab fa-paypal"></i>
							<span><b>PayPal</b></span>
							<span>Pay using your Paypal account.
								<template v-if="total >= 30">
									Option to pay later is available
								</template>
							</span>
						</label>
					</p>
					<p class="fancy_radio_button" v-if="pay_on_account_enabled">
						<input type="radio" name="payment_type" id="payment_type_3" value="account" v-model="payment_method">
						<label for="payment_type_3">
							<i class="fal fa-folder-open"></i>
							<span><b>On Trade Account</b></span>
							<span>Pay on account and we'll invoice you.</span>
						</label>
					</p>
				</div>
			</template>
			<div v-if="this.payment_method=='stripe'" class="form_style">
				<p>
					<label for="name_on_card" class="required">Name on Card</label>
					<input type="text" id="name_on_card" name="name_on_card" v-model="name_on_card">
					<span class="validation-error" v-if="this.validationErrors.name_on_card">{{ this.validationErrors.name_on_card }}</span>
				</p>
				<div class="fake_p">
					<label for="card_number" class="required">Card Number</label>
					<div id="card_number"></div>
				</div>
				<div class="fake_p half">
					<label for="card_expiry" class="required">Expiry Date</label>
					<div id="card_expiry"></div>
				</div>
				<div class="fake_p half">
					<label for="card_cvc" class="required">CVC <small>required</small></label>
					<div id="card_cvc"></div>
				</div>
				<p style="justify-content: center; font-size: 12px;">Please note, paymenets are handled by Stripe. Stone and Surfaces never receive your card details.</p>
				<p style="justify-content: flex-end"><a href="https://stripe.com/" target="_BLANK"><img src="/images/powered_by_stripe.png" /></a><br><span class="stripe_ssl_logo"></span></p>
				<div id="card_errors"></div>
				<input type="hidden" name="_token" :value="csrf">
				<input type="hidden" name="billing_address" v-model="stripe_billing_address">
				<input type="hidden" name="stripe_method" value="card">
			</div>
			<template v-if="payment_method != ''">
				<p class="styled_checkboxes" v-if="this.has_consent=='0'">
					<input type="checkbox" name="opt_in" id="opt_in" value="1" v-model="opt_in">
					<label for="opt_in"><span>If you wish to receive news and offers from Stone & Surfaces Direct via email, please tick this box.</span></label>
				</p>

				<div class="terms_box" v-html="terms"></div>

				<p class="styled_checkboxes">
					<input type="checkbox" name="agree" id="agree" value="1" v-model="agree">
					<label for="agree"><span>I agree with the <a href="/terms-and-conditions-for-the-sale-of-products" taget="_blank">Terms of Use</a></span></label>
				</p>

				<p class="styled_checkboxes" v-if="kerbside_option">
					<input type="checkbox" name="kerbside" id="kerbside" value="1" v-model="kerbside">
					<label for="kerbside"><span>I understand delivery is kerbside, and a hydraulic pallet truck is used to move the consignment onto my property.
						<br>(Our delivery partner, Pallet Track will make every effort to move the pallet as close to your house as possible.)
						<br>View our <a href="/kerbside-delivery-info.pdf" target="_blank">delivery pdf</a> for more details.</span></label>
				</p>

				<div v-if="payment_method=='paypal'" class="form_style" :class="{ disabled: submittable == false || agree == false }">
					<div class="paypal-button-container" id="paypal-button-container"></div>
				</div>
				<p v-if="this.payment_method!='paypal'">
					<button id="proceed_button" class="button wide upper green arrow" :disabled="submittable == false || agree == false || (kerbside_option == true && kerbside == false)" v-on:click.prevent="placeOrder()">Place Order</button>
				</p>
			</template>

		</div>
	</form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
	props: [
		'billing_address',
		'bypass_payment',
		'has_consent',
		'terms',
		'stripe_enabled',
		'stripe_key',
		'paypal_enabled',
		'pay_on_account_enabled',
		'total',
		'kerbside_option'
	],
	computed: {
		...mapGetters({
		}),
		enabled_payment_methods: function () {
			var count = this.stripe_enabled + this.paypal_enabled + this.pay_on_account_enabled;
			return count;
		},
	},

	data: () => {
		return {
			validationErrors: {
				name_on_card: null
			},
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			name_on_card: '',
			submittable: true,
			agree: false,
			opt_in: false,
			kerbside: false,
			payment_method: '',
			// stripe variables
			stripe_initialised: false,
			stripe_action: '/checkout/payment/stripe',
			stripe_handler: '/checkout/payment/stripe-handler',
			name_on_card: '',
			stripe_billing_address: '',
			// paypal variables
			paypal_initialised: false,
			// account payment variables
			account_payment_action: '/checkout/payment/on-account',
			// no charge variabled
			bypass_payment_action: '/checkout/payment/no-charge',
		}
	},

	watch: {
		payment_method: function (value) {
			if (value == 'stripe' && !this.stripe_initialised) {
				initialiseStripe(this.stripe_key);
				this.stripe_initialised = true;
			}
			if (value == 'paypal' && !this.paypal_initialised) {
				this.$nextTick(function () {
					initialisePaypal();
					this.paypal_initialised = true;
				});
			}
		}
	},

	mounted() {
		if (this.enabled_payment_methods == 1) {
			if (this.stripe_enabled == true) { this.payment_method = 'stripe'; }
			if (this.paypal_enabled == true) { this.payment_method = 'paypal'; }
			if (this.pay_on_account_enabled == true) { this.payment_method = 'account'; }
		}
		if (this.bypass_payment=='1') {
			this.payment_method = 'no-charge';
		}
		this.stripe_billing_address = JSON.stringify(this.formatAddress(this.billing_address));
	},

	methods: {
		...mapActions(["addAlert"]),

		// THE PLACE ORDER BUTTON HAS BEEN CLICKED, HANDLE WHAT HAPPENS NEXT
		placeOrder: function() {

			this.submittable = false;
			$('#proceed_button').removeClass('arrow').addClass('spinner');

			if (this.payment_method == 'stripe') {

				$('#PaymentForm').attr('action', this.stripe_action);

				var validated = true;
				if (this.name_on_card == '') {
					validated = false;
					this.validationErrors.name_on_card = "Please enter the name on your card";
					this.addAlert({
						alertClass: 'alert-danger',
						alertMessage: '<strong>Error</strong> Please enter the name on card',
						alertImportant: false,
					})

					$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
					this.submittable = true;
				}

				if (validated) {
					var stripe_key = this.stripe_key;
					var form_id  = 'PaymentForm';
					var name_on_card_field = 'name_on_card';
					var card_errors_div = 'card_errors';
					var stripe_handler = this.stripe_handler;
					this.submitStripe(stripe_key, form_id, name_on_card_field, card_errors_div, stripe_handler ,this.formatAddress(this.billing_address));
				}
			} else if (this.payment_method == 'paypal') {
			}else if (this.payment_method == 'account') {
				$('#PaymentForm').attr('action', this.account_payment_action).submit();
			}else{
				$('#PaymentForm').attr('action', this.bypass_payment_action).submit();
			}


		},

		formatAddress: function(address) {
			var formattedAddress = {
				first_name: address.first_name,
				last_name: address.last_name,
				street_1: address.address_1,
				street_2: address.address_2,
				street_3: address.address_3,
				city: address.town,
				county: address.county,
				country_id: '',
				postcode: address.postcode,
				telephone: address.telephone,
			};
			return formattedAddress;
		},

		submitStripe: function(stripe_key, form_id, name_on_card_field, card_errors_div, stripe_handler, billing_address) {

			// Handle form submission
			form = document.getElementById(form_id);
			var cardholderName = document.getElementById(name_on_card_field);
			errors_div = card_errors_div;
			var self = this;

			stripe.createPaymentMethod('card', cardNumber, {
				billing_details: {
					name: billing_address.first_name + ' ' + billing_address.last_name,
					email: billing_address.email,
					phone: billing_address.telephone,
					address: {
						line1: billing_address.street_1,
						line2: billing_address.street_2,
						city:  billing_address.city,
						state: billing_address.county,
						postal_code: billing_address.postcode,
					},
				},
			}).then(function(result) {
				if (result.error) {
					// Show error in payment form
					$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
					self.submittable = true;
					showErrorMessage(result.error.message);
				} else {
					// Otherwise send paymentMethod.id to your server (see Step 2)
					fetch(stripe_handler, {
						method: 'POST',
						headers: {
							"Content-Type": "application/json",
							"Accept": "application/json",
							"X-Requested-With": "XMLHttpRequest",
							"X-CSRF-Token": $('input[name="_token"]').val()
						},
						body: JSON.stringify({
							payment_method_id: result.paymentMethod.id,
							billing_address: billing_address,
							opt_in: self.opt_in
						})
					}).then(function (result) {
						// Handle server response (see Step 3)
						result.json().then(function (json) {
							self.handleServerResponse(json, form_id, stripe_handler);
						})
					});
				}
			});
		},

		handleServerResponse: function(response, form_id, stripe_handler) {
			var self = this;
			var form = document.getElementById(form_id);
			if (response.error) {
				// Show error from server on payment form
				$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
				showErrorMessage(response.error);
			} else if (response.requires_action) {
				// Use Stripe.js to handle required card action
				stripe.handleCardAction(
					response.payment_intent_client_secret
				).then(function(result) {
					if (result.error) {
						// Show error in payment form
						$('#proceed_button').removeClass('spinner').addClass('arrow').prop("disabled", false);
						self.submittable = true;
						showErrorMessage(result.error.message);
					} else {
						// The card action has been handled
						// The PaymentIntent can be confirmed again on the server
						fetch(stripe_handler, {
							method: 'POST',
							headers: {
								"Content-Type": "application/json",
								"Accept": "application/json",
								"X-Requested-With": "XMLHttpRequest",
								"X-CSRF-Token": $('input[name="_token"]').val()
							},
							body: JSON.stringify({
								payment_intent_id: result.paymentIntent.id,
								opt_in: self.opt_in
							})
						}).then(function(result) {
							result.json().then(function (json) {
								self.handleServerResponse(json, form_id, stripe_handler);
							})

						});
					}
				});
			} else {
				// Show success message
				this.addAlert({
					alertClass: 'alert-success',
					alertMessage: '<strong>Success</strong> Your order has been placed. You should now be redirected to the confirmation screen.',
					alertImportant: true,
				});
				form.submit();
			}
		}

	},





};

function showErrorMessage(message = '') {
	var feedback_box = document.getElementById(errors_div);
	feedback_box.innerHTML = message;
}

var stripe = '';
var form = '';
var errors_div = '';
var elements;
var cardNumber;
var cardExpiry;
var cardCvc;
function initialiseStripe(stripe_key) {

	// Create a Stripe client
	stripe = Stripe(stripe_key);

	// Define element styles
	var elementStyles = {
		base: {
			iconColor: '#3ba935',
			color: '#333',
			lineHeight: '1.4em',
			fontSize: '14px',
			':-webkit-autofill': {
				color: '#67b9b1',
			},
		},
		invalid: {
			iconColor: '#c82333',
			color: '#c82333',
		},
	};

	// Define element classes
	var elementClasses = {
		focus: 'focus',
		empty: 'empty',
		invalid: 'invalid',
	};

	// Create an instance of Elements
	elements = stripe.elements();

	// Create the elements
	cardNumber = elements.create('cardNumber', { style: elementStyles, classes: elementClasses });
	cardNumber.mount('#card_number');

	cardExpiry = elements.create('cardExpiry', { style: elementStyles, classes: elementClasses });
	cardExpiry.mount('#card_expiry');

	cardCvc = elements.create('cardCvc', { style: elementStyles, classes: elementClasses });
	cardCvc.mount('#card_cvc');
}

function initialisePaypal() {
	paypal.Buttons({
		// Order is created on the server and the order id is returned
		createOrder: (data, actions) => {

			return fetch("/checkout/payment/paypal-get-order")
				.then(response => response.json())
				.then(data => {
					return actions.order.create(data);
				})
				.catch(error => {
					// handle the error
				});

		},
		// Finalize the transaction on the server after payer approval
		onApprove: (data, actions) => {
			return actions.order.capture()
				.then(function (orderData) {
					const transaction = orderData.purchase_units[0].payments.captures[0];

					if (transaction.status == 'COMPLETED') {
						var post_data = {
							paypal_data: orderData,
							other_data: data
						};
						if (document.getElementById('opt_in')) {
							post_data.opt_in = document.getElementById('opt_in').checked;
						}
						axios.post('/checkout/payment/paypal-confirmed', post_data).then(response => {
							window.location.replace(response.data);
						}).catch(error => {
							// handle the error
						});
					} else {
						alert("There was a problem with your payment. Please try again.");
					}


					// Successful capture! For dev/demo purposes:
					// console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
					// const transaction = orderData.purchase_units[0].payments.captures[0];
					// alert(`Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`);

				})
			;
		}
	}).render('#paypal-button-container');
}



</script>
